import Offer from "./contracts/Offer";
import Provider from "./contracts/Provider";
import PresentationType from "../enums/PresentationTypes";

export default class OfferImpl implements Offer {
    private id: string | number = "";
    private provider: Provider | null = null;
    private price: number | null = null;
    private currency: string | null = null;
    private url: string | null = null;
    private presentationType: PresentationType = PresentationType.Unknown;

    getId(): string | number {
        return this.id;
    }

    getProvider(): Provider | null {
        return this.provider;
    }

    getPrice(): number | null {
        return this.price;
    }

    getCurrency(): string | null {
        return this.currency;
    }

    getUrl(): string | null {
        return this.url;
    }

    getPresentationType(): PresentationType {
        return this.presentationType;
    }

    setId(value: string | number): Offer {
        this.id = value;
        return this;
    }

    setProvider(value: Provider | null): Offer {
        this.provider = value;
        return this;
    }

    setPrice(value: number | null): Offer {
        this.price = value;
        return this;
    }

    setCurrency(value: string | null): Offer {
        this.currency = value;
        return this;
    }

    setUrl(value: string | null): Offer {
        this.url = value;
        return this;
    }

    setPresentationType(value: PresentationType): Offer {
        this.presentationType = value;
        return this;
    }

}